module.exports = __webpack_public_path__ + "static/media/x.5951b405.svg";